if (!customElements.get('home-slideshow')) {
  customElements.define('home-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.slides = [...this.querySelectorAll('.home-promo__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.slides.length < 2) return;
      this.querySelector('.home-promo__controls').hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-slide')) {
          this.show(Number(button.dataset.slide));
          this.paused = false;
        }
        this.schedule();
      }, { signal });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => this.schedule(), { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => this.isConnected && this.schedule()), { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => { this.show(this.index); this.schedule(); }, { signal });
      this.addEventListener('touchstart', (event) => {
        this.touchStart = event.touches.length === 1 ? event.touches[0] : null;
      }, { signal, passive: true });
      this.addEventListener('touchend', (event) => {
        if (!this.touchStart) return;
        const end = event.changedTouches[0];
        const dx = end.clientX - this.touchStart.clientX;
        const dy = end.clientY - this.touchStart.clientY;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          this.show(this.index + (dx < 0 ? 1 : -1));
          this.schedule();
        }
      }, { signal, passive: true });
      this.addEventListener('touchcancel', () => { this.touchStart = null; }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.show(index); this.editorSelected = true; this.schedule(); }
      }, { signal });
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, { signal });
      this.schedule();
    }
    show(index) {
      const previous = this.index;
      this.transitions?.forEach(animation => animation.cancel());
      this.index = (index + this.slides.length) % this.slides.length;
      const fading = previous !== this.index && !this.motion.matches;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index && !(fading && i === previous);
        slide.inert = i !== this.index;
        slide.style.zIndex = i === this.index ? '1' : '';
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      if (fading) {
        const options = { duration: 600, easing: 'ease-in-out' };
        const outgoing = this.slides[previous];
        const incoming = this.slides[this.index];
        this.transitions = [
          outgoing.animate([{ opacity: 1 }, { opacity: 0 }], options),
          incoming.animate([{ opacity: 0 }, { opacity: 1 }], options)
        ];
        this.transitions[1].onfinish = () => { outgoing.hidden = true; };
      }
    }
    schedule() {
      clearTimeout(this.timer);
      const active = this.dataset.autoplay === 'true' && !this.paused && !this.hovered &&
        !this.contains(document.activeElement) && !document.hidden && !this.motion.matches && !this.editorSelected;
      this.querySelector('.home-promo__slides').setAttribute('aria-live', active ? 'off' : 'polite');
      if (active) this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() {
      this.transitions?.forEach(animation => animation.cancel());
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
}
